import React, { useEffect, useState } from 'react';
import { Card } from '../Card';
import CardTitle from '../Card/CardTitle';
import CardExtra from '../Card/CardExtra';
import Highlighter from 'react-highlight-words';
import styles from './SearchMobileCard.module.scss';
import { Icon } from '../Icon';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';

const SearchMobileFolder = ({ folder, searchInput }) => {
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    console.log('SearchMobileFolder folder', folder);
  }, []);

  return (
    <Card className={styles.videoCard} onClick={async () => history.push({ pathname: `/eg/folder/${folder.id}` })}>
      <div className={styles.cardContainer}>
        <div className={styles.iconContainer}>
          <Icon src="folders" className={styles.videoIcon} />
        </div>
        <div>
          <CardTitle className={styles.title}>
            <Highlighter
              highlightClassName="wordHighlighter"
              className={styles.titleList}
              searchWords={[searchInput]}
              autoEscape
              textToHighlight={folder.name}
            />
          </CardTitle>
          <CardExtra className={styles.cardExtra}>
            <span className={styles.videoDate}>{t('general.date', { date: new Date(`${folder.createdAt}`) })}</span>
          </CardExtra>
        </div>
      </div>
    </Card>
  );
};

export default SearchMobileFolder;
